import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.41 3.053a.67.67 0 0 0-.414.614v6.666a.667.667 0 1 0 1.333 0v-5.06l7.527 7.534a.666.666 0 0 0 .947 0 .67.67 0 0 0 0-.947L5.269 4.333h5.06a.667.667 0 1 0 0-1.333H3.663a.7.7 0 0 0-.254.053"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })